import React from "react";
import styled from "styled-components";

export default styled.div`
    font-size: 21px;
    color: #888888;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media(min-width:768px){
        gap: 30px;
    }

`;
